import { useState } from 'react';
import {
  HydrationDayConnectorApollo,
  HydrationDayChangeGoalConnectorApollo,
  HydrationAddConnectorApollo,
  HydrationDayPortionRemoveConnectorApollo,
  HydrationHistoryConnectorApollo,
  HydrationSaveSettingsConnectorApollo,
} from '@front-activerse/common-components';
import DayContainer from '../Hydration/Day/HydrationDayContainer';
import { subDays } from '@front-activerse/common-components';

const HydrationIndexPage = () => {
  const [length, setLength] = useState(7);
  const date = new Date();

  const to = new Date();
  const from = subDays(to, length - 1);
  return (
    <HydrationDayConnectorApollo date={date}>
      {({ loading, data: { goal, hydrationSum } = {}, queryResult }) => (
        <HydrationHistoryConnectorApollo dateFrom={from} dateTo={to}>
          {({ loading2, unit, defaultDailyGoal, days }) => (
            <HydrationDayChangeGoalConnectorApollo date={date} queryResult={queryResult}>
              {(changeGoal, changeGoalMessages) => (
                <HydrationSaveSettingsConnectorApollo>
                  {(hydrationSaveSettingsData) => (
                    <HydrationAddConnectorApollo
                      date={date}
                      queryResult={queryResult}
                      hydrationHistorydays={days}
                    >
                      {(createAdd, addPortionMessages) => (
                        <HydrationDayPortionRemoveConnectorApollo
                          date={date}
                          queryResult={queryResult}
                        >
                          {(removeLastPortion, removePortionMessages) => (
                            <DayContainer
                              loading={loading}
                              date={date}
                              changeGoal={changeGoal}
                              changeGoalMessages={changeGoalMessages}
                              hydrationSaveSettingsData={hydrationSaveSettingsData} // to update defaultDailyGoal (in user settings)
                              removeLastPortion={removeLastPortion}
                              removeLastPortionMessages={removePortionMessages}
                              goal={goal}
                              value={hydrationSum}
                              add={createAdd}
                              messages={addPortionMessages}
                              loading2={loading2}
                              dateFrom={from}
                              dateTo={to}
                              unit={unit}
                              defaultDailyGoal={defaultDailyGoal}
                              days={days}
                              historyLength={length}
                              setHistoryLength={setLength}
                            />
                          )}
                        </HydrationDayPortionRemoveConnectorApollo>
                      )}
                    </HydrationAddConnectorApollo>
                  )}
                </HydrationSaveSettingsConnectorApollo>
              )}
            </HydrationDayChangeGoalConnectorApollo>
          )}
        </HydrationHistoryConnectorApollo>
      )}
    </HydrationDayConnectorApollo>
  );
};

export default HydrationIndexPage;
